import api from "./api";

export async function renovarUrlArquivo(file) {
  if (!file?.id) return file?.fileRef || file?.file_ref || "";
  const { data } = await api.http.get(`/arquivos/${file.id}/signed-url`);
  return data.fileRef;
}
